<template>
    <basicSearch :onSearchApi="onSearchApi" placeholder="搜索场馆" v-bind="$attrs" v-on="$listeners"></basicSearch>
</template>

<script>

import basicSearch from '@/components/basic/search.vue';
import { searchVenue } from '@/api/ballsports/base/venue';

export default {
    name: "venue-search",
    components: {
        basicSearch
    },
    data () {
        return {
            onSearchApi: searchVenue,
        }
    }
}
</script>
